import React from 'react';
import { Navigation } from '../components/Navigation';
import { ServicesSection } from '../components/ServicesSection';
import { GroomingSection } from '../components/GroomingSection';
import { Footer } from '../components/Footer';

const ServicesPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-20">
        <ServicesSection />
        <GroomingSection />
      </div>
      <Footer />
    </div>
  );
};

export default ServicesPage;
